import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { TableColumn } from 'react-data-table-component';
import axios, { AxiosRequestConfig } from "axios";
import Swal from "sweetalert2";

import { ShowBlocker } from '../../Components/LoaderComponent/LoaderComponent';
import DataGrid from '../../Components/DataGrid/DataGrid';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import ProfileServices from '../../Services/ProfileServices';


export interface IRejectedUserDetails {
    userId: string,
    userName: string,
    email :  string ,
    mobileNumber :  string ,
}

export interface UserManagementProps {
   
    
 }

export interface UserManagementState {
    accessToken: string;
    userData: IRejectedUserDetails[],
    currentRowsPerPage: number,
    currentPage: number,
    totalRows: number,
    searchText: string,
    currentSortColumn: string,
    sortingDirection: string,

}


class ManualAssistance extends React.Component<UserManagementProps, UserManagementState> {

    constructor(props_: any) {
        super(props_);

        this.state = {
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            userData: [],
            currentSortColumn: '',
            sortingDirection: ''

        }
    }

    private formColumns: TableColumn<IRejectedUserDetails>[] = [
        {
            name: 'Taxpayer Name',
            selector: (row: IRejectedUserDetails) => row.userName,
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row: IRejectedUserDetails) => row.email,
            sortable: true,
        },

        {
            name: 'Mobile Number',
            selector: (row: IRejectedUserDetails) => row.mobileNumber,
            sortable: true,
        }
    ];



    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getAllUsers();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    updateFormSubmission(userId: string, key: string) {

        try {
            let url = process.env.REACT_APP_API_URL + 'admin/updateSubmission';
            ShowBlocker(true);
            axios
                .post(url, { userId: userId, formName: key })
                .then((response) => {
                    ShowBlocker(false);
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Updated IRS Submission successfully",
                    });

                }).catch((err) => {
                    ShowBlocker(false);
                });
        }
        catch (ex) {

        }

    }

    getAllUsers() {

        let pageIndex: number = (this.state.currentPage - 1);
        let sortingObj: any = {};
        if (this.state.currentSortColumn != '') {
            sortingObj['column'] = this.state.currentSortColumn;
            sortingObj['direction'] = this.state.sortingDirection;
        }
        let pagination: any = {
            "offset": (pageIndex * this.state.currentRowsPerPage),
            "limit": this.state.currentRowsPerPage,
            "sort": { ...sortingObj },
            "searchFilter": this.state.searchText
        };

        ProfileServices.getAllRejectedUsers(pagination, this.state.accessToken).then((r) => {
            if (r.ok) {
                r.json().then(resp => {
                    this.setState({ userData: resp.result, totalRows: resp.totalCount });
                });
            }
        });
    }

  


    identifySortingMapColumn(columnName: string) {
        let actualColName = '';
        switch (columnName) {
            case "Taxpayer Name":
                actualColName = 'userName';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Mobile Number":
                actualColName = 'mobileNumber';
                break;
        }
        return actualColName;
    }

    public render() {
        return (
            <div className='body-sub-contianer table-container'>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    title='Users for manual review'
                    search='User Details'
                    columns={this.formColumns}
                    data={this.state.userData}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getAllUsers();
                        })
                    }}

                     onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                         this.setState({
                            currentPage: currentPage,
                            currentRowsPerPage: currentRowsPerPage
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        console.log(page, totalRows);
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    onSort={(column: any, direction) => {

                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    pagination
                    paginationTotalRows={this.state.totalRows}
                />
            </div>
        )
    }
}

export default ManualAssistance;